// src/pages/commercial/ClientRoomPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import pb from '../../lib/pocketbase';

export default function ClientRoomPage() {
    const { dealId } = useParams(); // Start with dealId, fetch associated data
    const [deal, setDeal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [customer, setCustomer] = useState(null);

    useEffect(() => {
        async function fetchRoomData() {
            try {
                const dealData = await pb.collection('deals').getOne(dealId, { expand: 'customer_id' });
                setDeal(dealData);
                if (dealData.expand?.customer_id) {
                    setCustomer(dealData.expand.customer_id);
                }
            } catch (err) {
                console.error("Room not found", err);
            } finally {
                setLoading(false);
            }
        }
        if (dealId) fetchRoomData();
    }, [dealId]);

    if (loading) return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0f172a', color: 'white' }}>Chargement de votre espace...</div>;
    if (!deal) return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0f172a', color: 'white' }}>Espace introuvable ou expiré.</div>;

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
            {/* Header */}
            <div style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 800, fontSize: '1.5rem', background: 'linear-gradient(135deg, #4f46e5, #ec4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    InfoColab
                </div>
                {customer && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '0.9rem', color: '#64748b' }}>Préparé pour</div>
                            <div style={{ fontWeight: 700, color: '#0f172a' }}>{customer.company || customer.name}</div>
                        </div>
                        <div style={{ width: 40, height: 40, background: '#e2e8f0', borderRadius: '50%', display: 'grid', placeItems: 'center', fontWeight: 700 }}>
                            {customer.name.charAt(0).toUpperCase()}
                        </div>
                    </div>
                )}
            </div>

            <div style={{ maxWidth: 1000, margin: '40px auto', padding: '0 20px', display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 40 }}>
                {/* Main Content */}
                <div>
                    <div style={{ background: 'white', padding: 40, borderRadius: 24, boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)', marginBottom: 40 }}>
                        <h1 style={{ fontSize: '2.5rem', fontWeight: 800, color: '#0f172a', marginTop: 0, lineHeight: 1.1 }}>
                            {deal.title}
                        </h1>
                        <p style={{ fontSize: '1.1rem', color: '#475569', lineHeight: 1.6 }}>
                            Nous sommes ravis de vous présenter cette proposition sur-mesure.
                            Voici les détails de notre future collaboration.
                        </p>

                        <div style={{ marginTop: 32, padding: 24, background: '#f1f5f9', borderRadius: 16 }}>
                            <h3 style={{ margin: '0 0 16px 0' }}>Votre Solution</h3>
                            <div style={{ color: '#334155' }}>
                                {/* Example static content, typically fetched from a 'proposal' field */}
                                <ul style={{ paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
                                    <li>Analyse approfondie de vos besoins</li>
                                    <li>Développement de la solution technique</li>
                                    <li>Accompagnement et formation</li>
                                    <li>Support prioritaire 24/7</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Placeholder for embedded video/doc */}
                    <div style={{ background: '#0f172a', borderRadius: 24, aspectRatio: '16/9', display: 'grid', placeItems: 'center', color: 'white' }}>
                        <div>
                            <span style={{ fontSize: '4rem' }}>▶️</span>
                            <p style={{ textAlign: 'center', opacity: 0.7 }}>Vidéo de présentation</p>
                        </div>
                    </div>
                </div>

                {/* Sidebar CTA */}
                <div>
                    <div style={{ position: 'sticky', top: 40, background: 'white', padding: 32, borderRadius: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontSize: '0.9rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            Investissement
                        </div>
                        <div style={{ fontSize: '3rem', fontWeight: 800, color: '#0f172a', margin: '8px 0 24px 0' }}>
                            {deal.amount ? `${new Intl.NumberFormat('fr-FR').format(deal.amount)}€` : 'Sur devis'}
                        </div>

                        <button style={{ width: '100%', padding: '16px', background: '#4f46e5', color: 'white', border: 'none', borderRadius: 12, fontSize: '1.1rem', fontWeight: 700, cursor: 'pointer', marginBottom: 16, boxShadow: '0 10px 20px -5px rgba(79, 70, 229, 0.4)' }}>
                            Accepter la proposition
                        </button>
                        <button style={{ width: '100%', padding: '16px', background: 'white', color: '#0f172a', border: '2px solid #e2e8f0', borderRadius: 12, fontSize: '1rem', fontWeight: 600, cursor: 'pointer' }}>
                            Poser une question
                        </button>

                        <div style={{ marginTop: 24, borderTop: '1px solid #e2e8f0', paddingTop: 24 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix" alt="Commercial" style={{ width: 48, height: 48, borderRadius: '50%', background: '#e2e8f0' }} />
                                <div>
                                    <div style={{ fontWeight: 700, color: '#0f172a' }}>Votre contact</div>
                                    <div style={{ color: '#64748b', fontSize: '0.9rem' }}>Léon (InfoColab)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
